import React from 'react';
import { Link } from 'react-router-dom';

import {
  getCategoryLink,
} from '../../utils/newsSeo';
import { getSectionRoute } from '../../utils/newsSectionRoutes';
import { normalizeNewsSections } from '../../utils/newsSections';
import UserAvatar from '../UserAvatar';

const NewsMeta = ({
  news,
  authorProfile,
  views,
}) => {
  const categoryLink =
    getCategoryLink(news.category);
  const authorId =
    authorProfile?.id || news.authorId || news.authorUid || null;
  const authorName = authorProfile?.username || news.author || 'Редакція BigSPORT';
  const sections = normalizeNewsSections(news);
  const resolvedPhotoURL = String(
    authorProfile?.photoURL || news.authorPhotoURL || ''
  ).trim() || null;
  const authorAvatar = (
    <UserAvatar
      photoURL={resolvedPhotoURL}
      name={authorName}
      email={authorProfile?.email}
      size={28}
      className="news-author-avatar"
      alt={`Фото автора ${authorName}`}
    />
  );

  return (
    <div className="single-news-meta">
      <div className="news-meta-item">
        <span className="news-meta-label">Дата:</span>{' '}
        {news.day}.
        {news.month}.
        {news.year}{' '}
        {news.time}
      </div>

      <div className="news-meta-item">
        <span className="news-meta-label">Категорія:</span>{' '}

        {categoryLink ? (
          <Link
            to={categoryLink}
            className="meta-link news-meta-chip news-meta-chip--link"
          >
            {news.category}
          </Link>
        ) : (
          news.category || '—'
        )}
      </div>

      {sections.length > 0 && (
        <div className="news-meta-item news-meta-sections">
          <span className="news-meta-label">Розділи:</span>
          <span className="news-meta-section-list">
            {sections.map((section) => {
              const sectionRoute = getSectionRoute(section, news);

              return sectionRoute ? (
                <Link
                  className="news-section-badge news-meta-chip news-meta-chip--link"
                  key={section}
                  to={sectionRoute}
                >
                  {section}
                </Link>
              ) : (
                <span
                  className="news-section-badge news-meta-chip"
                  key={section}
                >
                  {section}
                </span>
              );
            })}
          </span>
        </div>
      )}

      <div className="news-meta-item news-meta-author">
        <span className="news-meta-label">Автор:</span>

        {authorId ? (
          <Link
            to={`/profile/${authorId}`}
            className="news-author-link"
            aria-label={`Переглянути профіль автора ${authorName}`}
          >
            {authorAvatar}
            <span className="news-author-name">{authorName}</span>
          </Link>
        ) : (
          <span className="news-author-link">
            {authorAvatar}
            <span className="news-author-name">{authorName}</span>
          </span>
        )}
      </div>

      <div className="news-meta-item">
        <span className="news-meta-label">Перегляди:</span>{' '}
        {views}
      </div>
    </div>
  );
};

export default NewsMeta;
